import { useEventListener } from '@iwbam/react-ez';
import React, { useState } from 'react'

const Resizer = ({ ref, setHeight, containerRef }: { ref: React.RefObject<HTMLDivElement>, containerRef: React.RefObject<HTMLDivElement>, setHeight: React.Dispatch<React.SetStateAction<number>> }) => {

  const [isDragging, setIsDragging] = useState(false);

  useEventListener('mousemove', (e) => {
    if (isDragging) {
      // get cursor position
      const y = e.pageY;
      const rect = containerRef.current?.getBoundingClientRect();
      if (rect) {
        setHeight(Math.max(80, rect.bottom - y));
      }
    }
  });

  useEventListener('mouseup', () => {
    setIsDragging(false);
  })

  return (
    <div className='resizer absolute w-full h-1.5 top-0' onMouseDown={() => setIsDragging(true)} ref={ref} />
  )
}

export default Resizer